import { useState, useEffect } from 'react';
import apiService from '../services/apiService'; // Centralized API service

const usePaymentsOneBillId = (biller, refreshKey) => {
  const [payments, setPayments] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchPayments = async () => {
      setLoading(true);
      try {
        const response = await apiService.getPaymentsOneBillId(biller);
        const { items } = response;
        setPayments(items);
        setError(null);
      } catch (err) {
        console.error(err);
        setError(err.message || 'Error fetching payments');
      } finally {
        setLoading(false);
      }
    };
    fetchPayments();
  }, [biller, refreshKey]);

  return { payments, loading, error, refreshKey };
};

export default usePaymentsOneBillId;
